<template>
  <div class="nav">
      <router-link to="/web">
        <div class="imgBox">
          <div class="unmonitor imgTab" :class="{monitor:monitorT}">网站监控</div>
        </div>
      </router-link>
      <router-link to="/company" v-if='ifYg'>
        <div class="imgBox">
          <div class="uncompany imgTab" :class="{company:companyT}">公司服务</div>
        </div>
      </router-link>
      <router-link to="/laboratory">
        <div class="imgBox">
          <div class="unlaboratory imgTab" :class="{laboratory:laboratoryT}">实验室</div>
        </div>
      </router-link>
      <router-link to="/me">
        <div class="imgBox" >
          <div class="unpersonal imgTab" :class="{personal:personalT}">个人中心</div>
        </div>
      </router-link>
      <router-link to="/news" v-if='this.$store.state.ifLogin'>
        <div class="imgBox" >
          <div class="unnews imgTab" :class="{news:newsT}">消息</div>
        </div>
      </router-link>
  </div>
</template>

<script>

export default {
  data() {
    return {
      speedT:false,
      monitorT:false,
      personalT:false,
      serverT:false,
      laboratoryT:false,
      companyT:false,
      newsT:false
    };
  },
  mounted(){
    var path = this.$route.path
    if (path === '/web') {
      this.monitorT = true;
    }else if(path === '/me') {
      this.personalT = true;
    }else if(path === '/project') {
      this.speedT = true;
    }else if(path === '/server') {
      this.serverT = true;
    }else if(path === '/laboratory') {
      this.laboratoryT = true;
    }else if(path === '/company') {
      this.companyT = true;
    }else if(path === '/news') {
      this.newsT = true;
    }
  },
  computed:{
      ifYg() {
        return this.$store.state.ifYg
      }
    },
};
</script>

<style scoped lang="less">
  .nav {
    width: 100%;
    font-size: 12px;
    background: #20252f;
    line-height: 100px;
    height: 65px;
    display: flex;
    box-shadow: 5px 0 5px #000;
    position: fixed;
    bottom:0;
    left:0;
    z-index: 99;
    a {
      text-decoration: none;
      color: #fff;
      flex: 1;
      .imgBox{
        width: 100%;
        height: 100%;
        .imgTab{
          width: 48px;
          height: 48px;
          background-size: 60%;
          background-position: center;
          background-repeat: no-repeat;
          margin: 0 auto;
        }
        .unmonitor {
          background-image: url(../assets/unmonitor.png);
        }
        .unpersonal{
          background-image: url(../assets/unpersonal.png);
        }
        .unspeed{
          background-image: url(../assets/unspeed.png);
        }
        .unserver{
          background-image: url(../assets/unserver.png);
        }
        .unlaboratory{
          background-image: url(../assets/unlaboratory.png);
        }
        .uncompany{
          background-image: url(../assets/uncompany.png);
        }
        .unnews{
          background-image: url(../assets/unnews.png);
        }
        .monitor {
          background-image: url(../assets/monitor.png);
        }
        .personal{
          background-image: url(../assets/personal.png);
        }
        .speed{
          background-image: url(../assets/speed.png);
        }

        .server{
          background-image: url(../assets/server.png);
        }
        .laboratory{
          background-image: url(../assets/laboratory.png);
        }
        .company{
          background-image: url(../assets/company.png);
        }
        .news{
          background-image: url(../assets/news.png);
        }
      }
      
    }
    .router-link-active{
      color: #4f86ed;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MobileNav.vue